import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Banner } from '../Banner/Banner';
import { jsx as _jsx } from "react/jsx-runtime";
export const GeneralInformationBanner = ({
  onClose,
  message
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: message && /*#__PURE__*/_jsx(Banner, {
      title: message.text,
      link: message.url ? {
        title: t('global.moreInfo'),
        url: message.url
      } : undefined,
      onClose: () => {
        onClose(message.id);
      }
    })
  });
};